<script>
    import {onMount} from "svelte";

    /*
    * Esimerkki dioista joita tälle voi antaa
    * let slides = [
        {id: 1, src: "./kasipainot.jpg", content: "Tilaa kahdessa tasossa"},
        {id: 2, src: "./kuulat.png", content: "Puitteet monipuoliseen harjoitteluun"},
        {id: 3, src: "./kuulat.png", content: "Taatusti tehokasta"},
        {id: 4, src: "./kasipainot.jpg", content: "Aloita nyt!", contentType: "Button" , contentUrl: "https://holvi.com/shop/dynamosali/"},
    ];
    * */
    export let sliderSlides = [];
    export let sliderSpeedMs = 7000;
    let slideIndex = 1;

    function nextSlide() {
        if (slideIndex == sliderSlides.length) {
            slideIndex = 1;
        } else {
            slideIndex++;
        }
    }

    function prevSlide() {
        if (slideIndex === 1) {
            slideIndex = sliderSlides.length;
        } else {
            slideIndex--;
        }
    }

    onMount(async () => {

        setInterval(function () {
            nextSlide();
        }, sliderSpeedMs);
    });
</script>

<div class="sliderContainer">
    <div>

        {#each sliderSlides as s}
            {#if slideIndex == s.id}
                <div class="slider-img" style="background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url('{s.src}');"></div>
                <div class="sliderContentContainer">
                    {#if s.header && s.header === "empty"}
                        <div class="sliderHeader">&nbsp;</div>
                    {/if}
                    {#if s.header && s.header !== "empty"}
                        <h1 class="sliderHeader primary">{s.header}</h1>
                    {/if}
                    {#if s.content && s.content !== "empty"}
                        <div class="sliderHeader secondary">{s.content}</div>
                    {/if}
                    {#if s.buttonTxt && s.buttonTxt !== "empty"}
                        <div class="sliderContentButton">
                            <div class="hero-img-body">
                                {#if s.target}  
                                    <a href="{s.contentUrl}" target="{s.target}">{s.buttonTxt}</a>
                                {:else}
                                    <a href="{s.contentUrl}">{s.buttonTxt}</a>
                                {/if}
                            </div>
                        </div>
                    {/if}
                </div>
            {/if}
        {/each}

    </div>
    <!--
    <div class="slideArrows">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <div class="handle left-handle" on:click={prevSlide}><span class="carousel-control-prev-icon"
                                                                   aria-hidden="true"></span></div>
        <div class="handle right-handle" on:click={nextSlide}><span class="carousel-control-next-icon"
                                                                    aria-hidden="true"></span></div>
    </div>
    
    <ol class="carousel-indicators">
        {#each sliderSlides as s}
            {#if slideIndex == s.id}
                <li class="active"></li>
            {:else}
                <li class=""></li>
            {/if}
        {/each}
    </ol>
    -->
</div>

<style>
    .sliderContainer {
        height: 400px;
        position: relative;
    }

    .slider-img {
        width: 100%;
        max-width: 100%;
        height: 400px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
    }

    .sliderContentContainer {
        position: absolute;
        top: 100px;
        width: 100%;
    }

    .sliderHeader {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
        color: white;
        text-align: center;
    }
    .sliderHeader.primary {
        text-transform:uppercase;
        font-size: 36px;
    }
    .sliderHeader.secondary {
        font-size: 24px;
    }

@media all and (max-width: 600px) {
    .sliderHeader.primary {
        font-size: 32px;
    }
    .sliderHeader.secondary {
        font-size: 16px;
    }
} 

@media all and (min-width: 901px) {
    .sliderHeader.primary {
        font-size: 48px;
    }
    .sliderHeader.secondary {
        font-size: 32px;
    }
} 

    .handle {
        color: white;
        top: 37%;
        width: 35px;
        text-align: center;
        height: 100px;
        line-height: 102px;
        opacity: 0.5;
        position: absolute;
        background-color: darkgray;
        border-radius: 5px;
    }

    .handle:hover {
        background-color: gray;
        cursor: pointer;
    }

    .left-handle {
        left: 0;
    }

    .right-handle {
        right: 0;
    }

</style>
